import React from 'react';

export default function Ingredients(props) {
    const { hops, malts, yeast } = props;
    const newHops = [... new Set(hops)];
    const newMalts = [... new Set(malts)];
    return (
        <section>
            <div className="px-3">
                <details>
                    <summary className="py-3 mb-3"><h4 className="d-inline-block m-0">Ingredients:</h4></summary>
                    <div>
                        <h5>Malts:</h5>
                        <div className="row">
                            {newMalts.map((malt, i) =>
                                <div key={i} className="col-md-6">
                                    <div className="p-3">
                                        <p className="m-0">{malt.name} : {malt.amount.value} {malt.amount.unit}</p>
                                    </div>
                                </div>
                            )
                            }
                        </div>
                        <div className="p-3 pt-0">
                            <hr />
                        </div>
                        <h5>Hops:</h5>
                        <div className="row">
                            {newHops.map((hop, i) =>
                                <div key={i} className="col-md-6">
                                    <div className="p-3">
                                        <p className="m-0">Hop added at {hop.add} for {hop.attribute}<br />
                                            {hop.name} : {hop.amount.value} {hop.amount.unit}</p>
                                    </div>
                                </div>
                            )
                            }
                        </div>
                        <div className="p-3 pt-0">
                            <hr />
                        </div>
                        <div>
                            <h5>Yeast:</h5>
                            <p className="p-3">
                                {yeast}
                            </p>
                        </div>
                        <div className="px-3">
                            <hr />
                        </div>
                    </div>
                </details>

            </div>
        </section>
    )
}